/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { VApplication } from "../../../application";
import { GET_PRESENTATION } from "../graphql/getPresentation.query";
import { GET_BOXES } from "../graphql/getBoxes.query";
import { StorageModule } from "@vlinder-web/storage-module-react";
import { GET_OPEN_PRESENTATION } from "../graphql/getOpenPresentation.query";
import { GET_BANDS } from "../graphql/getBands.query";

const is = require("is_js");
const isVideo: any = /\.(mp4|mov|avi|avchd|flv|f4v|swf|mkv|webm|html5)$/i;
const isYoutubeVideo: any =
  /^(https?\:\/\/)?((www\.)?youtube\.com|youtu\.be)\/.+$/i;

const getGraphQLModule = () => {
  const app = VApplication.getInstance();
  return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};

export interface IGetPresentationMethods extends IPluginMethodMap {
  getPresentation(args: any): Promise<any>;
}

export class GetPresentationService implements IAgentPlugin {
  readonly methods: IGetPresentationMethods;

  constructor() {
    this.methods = {
      getPresentation: this.getPresentation.bind(this),
    };
  }

  async getPresentation(args: any) {
    const graphqlModule = getGraphQLModule();
    const storageSrv = StorageModule.getInstance();
    const loginSession = storageSrv?.get("userProfile", "session");
    const localSession = storageSrv?.get("userProfile", "local");

    const _token = loginSession ?? localSession;
    const client = graphqlModule.getClient("graphql-gateway");
    let presentationArray: any = [];

    try {
      if (client) {
        let band;
        if (is.existy(localStorage?.band)) {
          band = localStorage?.band;
        }
        console.log(band);
        const res1 = await client.query({
          query: GET_BANDS,
          variables: {
            filter: {
              bandName: band,
            },
          },
          fetchPolicy: "network-only",
        });
        let data: any[] = [];
        const boxRes = await client.query({
          query: GET_BOXES,
          variables: {},
          fetchPolicy: "network-only",
        });

        if (
          boxRes?.data?.getMyBoxes?.content &&
          boxRes?.data?.getMyBoxes?.content.length > 0
        ) {
          data = boxRes?.data?.getMyBoxes?.content;

          for (let obj of data) {
            if (obj?.presentation?.name && is.existy(obj?.presentation?.name)) {
              if (!presentationArray.includes(obj?.presentation?.name)) {
                presentationArray.push(obj?.presentation?.name);
              }
            }
          }
        }
        if (
          res1?.data?.getBand?.isMultiplePurchase ||
          (!res1?.data?.getBand?.isMultiplePurchase &&
            data &&
            data.length === 0)
        ) {
          const localStorageCostume = storageSrv?.get("costumeadata", "local");
          const res = await client.query({
            query: GET_PRESENTATION,
            variables: {},
            fetchPolicy: "network-only",
          });

          const res_data = res?.data?.getMyReferedSections?.myPresentations;
          let sectionArray: any = [];
          if (res_data && is.existy(res_data) && is.not.empty(res_data)) {
            for (let obj of res_data) {
              if (
                is.existy(obj) &&
                is.existy(obj?.status) &&
                is.existy(obj?.year) &&
                obj?.status === "active"
              ) {
                const payload = this.formatData(presentationArray, obj, band);
                if (payload && payload.length > 0) {
                  sectionArray.push(...payload);
                }
              }
            }
          }
          console.log(localStorageCostume?.id);
          return {
            sectionArray: sectionArray,
            redirect: "",
            refID: this.getReferalIdForOpenInvite(
              res?.data,
              localStorageCostume?.id
            ),
          };
        } else {
          console.log("execute else");
          return {
            redirect: "goToOrders",
          };
        }
      }
    } catch (err: any) {
      let _display_message =
        err?.graphQLErrors &&
        Array.isArray(err?.graphQLErrors) &&
        err?.graphQLErrors.find((item: any) => item.extensions);
      if (_display_message?.extensions?.display_message) {
        throw Error(_display_message?.extensions?.display_message);
      }

      throw err;
    }
  }

  private getListItems = (presentation: any, section: any) => {
    console.log(section, presentation);
    let listItems: any = [];
    let index = 0;

    if (presentation?.name && is.existy(presentation?.name)) {
      listItems.push({
        key: index.toString(),
        icon: "https://img.icons8.com/ios-filled/50/f5f5f5/instagram-check-mark.png",
        title: "Presentation Name",
        subtitle: presentation?.name,
      });

      index++;
    }
    const invitedBy = presentation?.referal?.invitedBy;
    if (invitedBy) {
      const fullName = [invitedBy?.firstName, invitedBy?.lastName]
        .filter(Boolean)
        .join(" ");
      const label = fullName || invitedBy?.email;

      listItems.push({
        key: index.toString(),
        icon: "https://img.icons8.com/ios-filled/50/f5f5f5/instagram-check-mark.png",
        title: "Committee",
        subtitle: label,
      });
      index++;
    }
    if (section?.myCostumeType && is.existy(section?.myCostumeType)) {
      let obj = section?.myCostumeType;
      if (obj && is.existy(obj) && is.not.empty(obj)) {
        listItems.push({
          key: index.toString(),
          icon: "https://img.icons8.com/ios-filled/50/f5f5f5/instagram-check-mark.png",
          title: "",
          subtitle: obj?.name,
        });
        index++;

        // if (obj?.minDownPayment && is.existy(obj?.minDownPayment)) {
        //   listItems.push({
        //     key: index.toString(),
        //     icon: "https://img.icons8.com/ios-filled/50/f5f5f5/instagram-check-mark.png",
        //     title: obj?.name + " Down Payment",
        //     subtitle: "TT$ " + obj?.minDownPayment,
        //   });

        //   index++;
        // }
      }
    }

    return listItems;
  };

  private extractImages(data: any, imagesArr: any[]) {
    if (data?.images && is.existy(data?.images) && is.not.empty(data?.images)) {
      for (let obj of data?.images) {
        if (obj && is.existy(obj)) {
          if (isVideo.test(obj)) {
            imagesArr.push({
              type: "video",
              src: obj,
            });
          } else if (isYoutubeVideo.test(obj)) {
            imagesArr.push({
              type: "video",
              src: obj,
            });
          } else {
            imagesArr.push({
              type: "img",
              src: obj,
            });
          }
        }
      }
    }

    return imagesArr;
  }

  private getAllSectionImages = (section: any) => {
    let imagesArr: any = [];

    imagesArr = this.extractImages(section, imagesArr);

    if (
      section?.myCostumeType &&
      is.existy(section?.myCostumeType) &&
      is.not.empty(section?.myCostumeType)
    ) {
      let obj = section?.myCostumeType;
      if (obj && is.existy(obj)) {
        imagesArr = this.extractImages(obj, imagesArr);
      }
    }

    return imagesArr;
  };

  private getDropDownListItems = (section: any, payload: any) => {
    let listItems: any = [];
    let partition: string = payload?.referal?.partition;

    if (section?.myCostumeType && is.not.empty(section?.myCostumeType)) {
      let obj = section?.myCostumeType;
      if (obj && is.existy(obj) && is.not.empty(obj) && obj?.isVisible) {
        switch (partition) {
          case "Default":
            obj.isMyCostumeTypeSold = obj?.inventoryDetail?.isDefaultSold;
            break;
          case "SectionSpecific":
            obj.isMyCostumeTypeSold =
              obj?.inventoryDetail?.isSectionSpecificSold;
            break;
          case "SpecialReserve":
            obj.isMyCostumeTypeSold =
              obj?.inventoryDetail?.isSpecialReserveSold;
            break;
        }

        if (obj?.isMyCostumeTypeSold) {
          obj.name = obj.name + " [sold out]";
        }

        // listItems.push(obj);
        listItems.push({ ...obj, refID: payload?.referal?.id });
      }
    }

    if (listItems.length > 0) {
      listItems.unshift({
        name: "Select options",
        id: "",
      });
    }

    return listItems;
  };

  private formatData(presentationArray: any, data: any, band: any) {
    let appCardList: any = [];

    if (data?.mySections && is.array(data?.mySections)) {
      for (let obj of data?.mySections) {
        console.log(obj);
        if (obj && is.existy(obj) && is.not.empty(obj)) {
          console.log(obj);
          console.log(
            data?.name,
            presentationArray,
            presentationArray.includes(data?.name)
          );
          const regMode = obj?.regMode
            ? String(obj.regMode).trim().toLowerCase().replace(/[\s_]+/g, "")
            : null;
          const isRegModeAllowed =
            regMode === null ||
            regMode === "" ||
            regMode === "open" ||
            regMode === "openandclosed";

          if (
            ((obj?.isVisible && !presentationArray.includes(data?.name)) ||
              (obj?.isVisible && presentationArray.includes(data?.name) && true)) &&
            isRegModeAllowed
            // band?.isMultiplePurchase
          ) {
            const invitedBy = data?.referal?.invitedBy;
            const fullName = [invitedBy?.firstName, invitedBy?.lastName]
              .filter(Boolean)
              .join(" ");
            const label = fullName || invitedBy?.email;
            appCardList.push({
              heroImage: {
                title: obj?.name,
                alias: obj?.alias,
              },
              title: obj?.name,
              subtitle: obj?.description,
              listItems: this.getListItems(data, obj),
              sectionAllImages: this.getAllSectionImages(obj),
              dropDownListItems: this.getDropDownListItems(obj, data),
              inviteType: data?.referal?.inviteType,
              invitedBy: label,
              refID: data?.referal?.id,
            });
          }
        }
      }
    }

    return appCardList;
  }

  private getReferalIdForOpenInvite(
    data: any,
    costumeTypeId: string
  ): string | null {
    console.log(data);
    console.log(costumeTypeId);
    if (!data?.getMyReferedSections?.myPresentations) {
      return null;
    }
    let matchedReferalId: string | null = null;

    for (const presentation of data?.getMyReferedSections?.myPresentations) {
      if (presentation?.mySections && Array.isArray(presentation?.mySections)) {
        for (const section of presentation?.mySections) {
          console.log("matchedReferalId===350");
          if (section?.myCostumeType?.id === costumeTypeId) {
            console.log("matchedReferalId===352");
            if (presentation?.referal?.inviteType === "Open") {
              console.log("matchedReferalId===354");
              matchedReferalId = presentation?.referal?.id;
            }
          }
        }
      }
    }
    console.log("matchedReferalId===", matchedReferalId);
    return matchedReferalId;
  }
}
